// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "profiler" + "." + "92368e197344fd9e07c9" + ".js";
};